import React from 'react';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { usePanelAreaContext } from 'components/Player/PanelAreaContext';

const StyledBox = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  boxShadow: '0 6px 6px rgba(0, 0, 0, 0.2)',
  overflow: 'auto',
  justifyContent: 'space-between',
  background: theme.palette.primaryContainer.light,
  padding: theme.spacing(2),
}));

const StyledTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.surfaceContainer.contrastText,
}));

type PanelAreaProps = {
  title: string;
  Body: JSX.Element | null;
  Footer?: JSX.Element | null;
};

export const PanelAreaContainer = ({ title, Body, Footer }: PanelAreaProps) => {
  const { setPanelAreaOpen } = usePanelAreaContext();

  return (
    <StyledBox data-testid='panel-area-container-box'>
      <Box>
        <Stack direction='row' spacing={1} justifyContent='space-between' alignItems='center'>
          <StyledTitle>
            <Typography variant='titleMedium'>{title}</Typography>
          </StyledTitle>
          <IconButton onClick={() => setPanelAreaOpen(false)}>
            <Close fontSize='small' />
          </IconButton>
        </Stack>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>{Body}</Box>
      <Box>{Footer}</Box>
    </StyledBox>
  );
};
